import { render, staticRenderFns } from "./GuideTypeSelectorModal.vue?vue&type=template&id=1642c684&scoped=true"
import script from "./GuideTypeSelectorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideTypeSelectorModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuideTypeSelectorModal.vue?vue&type=style&index=0&id=1642c684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642c684",
  null
  
)

export default component.exports